module.exports = __webpack_public_path__ + "static/bg-4c542a65648fe23a7150c48ca4c66f6e.jpg";